<div class="chart-container" *ngIf="this.isDataAvailable">
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 100%; display: block;">
  </highcharts-chart>
  <app-loader *ngIf="loading"></app-loader>
</div>

<app-no-widget-data *ngIf="!this.isDataAvailable && !loading"></app-no-widget-data>
